import React from 'react';
import PropTypes from 'prop-types';

import ListItem from './ListItem';

const ListItems = ({
  handleSelection,
  items,
  selectedItems,
  isSelectedBox,
}) => {
  const renderList = () =>
    items.map(item => {
      item.selected =
        selectedItems &&
        selectedItems.indexOf(item.id ? item.id : item.memriUserId) >= 0;
      return (
        <ListItem
          key={item.id ? item.id : item.memriUserId}
          {...item}
          selected={
            selectedItems &&
            selectedItems.indexOf(item.id ? item.id : item.memriUserId) >= 0
          }
          handleSelection={handleSelection}
          isSelectedBox={isSelectedBox}
        />
      );
    });

  return (
    <div className="multi-select-list">
      <ul
        className="vertical dropdown menu user-select-none accounts-multi-select-menu"
        data-dropdown-menu
      >
        {renderList()}
      </ul>
    </div>
  );
};

ListItems.propTypes = {
  handleSelection: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItems: PropTypes.instanceOf(Array),
  isSelectedBox: PropTypes.bool,
};

export default ListItems;
